import React, { useState } from "react";
import { Card, Table, Form, Row, Col, Button } from "react-bootstrap";
import { FaCalendarAlt, FaEdit, FaTrash } from "react-icons/fa";
import EditTerminationModal from "../../components/modals/hrm/termination/EditTerminationModal";
import DeleteTerminationModal from "../../components/modals/hrm/termination/DeleteTerminationModal";
import TerminationHeader from "../../components/hrm/holidays/TerminationHeader";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaChevronDown } from "react-icons/fa";

const TerminationPage = () => {
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedRange, setSelectedRange] = useState("Last 7 Days");

  const [dateRange, setDateRange] = useState({
    from: "",
    to: "",
  });

  const [selectedItem, setSelectedItem] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  // ✅ Dummy Data
const data = [
  {
    id: 1,
    name: "Anthony Lewis",
    image: "/assets/img/users/user-32-1.jpg",
    department: "Finance",
    type: "Retirement",
    notice: "2024-01-14",
    reason: "Employee retires",
    resignation: "2024-03-14",
  },
  {
    id: 2,
    name: "Brian Villalobos",
    image: "/assets/img/users/user-09.jpg",
    department: "Application Development",
    type: "Insubordination",
    notice: "2024-01-21",
    reason: "Entrepreneurial Pursuits",
    resignation: "2024-03-21",
  },
  {
    id: 3,
    name: "Harvey Smith",
    image: "/assets/img/users/user-01-1.jpg",
    department: "Web Development",
    type: "Layoff",
    notice: "2024-02-18",
    reason: "Workforce reduction",
    resignation: "2024-04-18",
  },
  {
    id: 4,
    name: "Stephan Peralt",
    image: "/assets/img/users/user-33-1.jpg",
    department: "UI / UX",
    type: "Breach of Contract",
    notice: "2024-03-14",
    reason: "Violates the terms of the contract",
    resignation: "2024-04-14",
  },
  {
    id: 5,
    name: "Doglas Martini",
    image: "/assets/img/users/user-34.jpg",
    department: "Marketing",
    type: "Lack of Skills",
    notice: "2024-04-10",
    reason: "Unable to perform job duties",
    resignation: "2024-06-10",
  },
  {
    id: 6,
    name: "Sophia Turner",
    image: "/assets/img/users/user-02.jpg",
    department: "HR",
    type: "Resignation",
    notice: "2024-02-05",
    reason: "Personal reasons",
    resignation: "2024-03-05",
  },
  {
    id: 7,
    name: "Daniel Carter",
    image: "/assets/img/users/user-03.jpg",
    department: "IT Support",
    type: "Termination",
    notice: "2024-01-30",
    reason: "Policy violation",
    resignation: "2024-02-28",
  },
  {
    id: 8,
    name: "Olivia Brown",
    image: "/assets/img/users/user-04.jpg",
    department: "Design",
    type: "Contract End",
    notice: "2024-03-01",
    reason: "Contract completed",
    resignation: "2024-03-30",
  },
  {
    id: 9,
    name: "James Anderson",
    image: "/assets/img/users/user-05.jpg",
    department: "Sales",
    type: "Layoff",
    notice: "2024-02-12",
    reason: "Budget cuts",
    resignation: "2024-04-12",
  },
  {
    id: 10,
    name: "Emma Wilson",
    image: "/assets/img/users/user-06.jpg",
    department: "Customer Support",
    type: "Resignation",
    notice: "2024-01-25",
    reason: "Career growth",
    resignation: "2024-02-25",
  },
];
  // ✅ Date helpers
  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-CA");

  const displayDate = (date) =>
    new Date(date).toLocaleDateString("en-GB");

  const calculateDates = (type) => {
    const today = new Date();
    let from = new Date();
    let to = new Date();

    switch (type) {
      case "Today":
        break;
      case "Yesterday":
        from.setDate(today.getDate() - 1);
        to = new Date(from);
        break;
      case "Last 7 Days":
        from.setDate(today.getDate() - 6);
        break;
      case "Last 30 Days":
        from.setDate(today.getDate() - 29);
        break;
      case "This Year":
        from = new Date(today.getFullYear(), 0, 1);
        break;
      case "Next Year":
        from = new Date(today.getFullYear() + 1, 0, 1);
        to = new Date(today.getFullYear() + 1, 11, 31);
        break;
      default:
        break;
    }

    return {
      from: formatDate(from),
      to: formatDate(to),
    };
  };

  // ✅ Filter
  const filteredData = data.filter((item) => {
    const matchSearch = item.name
      .toLowerCase()
      .includes(search.toLowerCase());

    const matchDate =
      dateRange.from && dateRange.to
        ? item.notice >= dateRange.from &&
          item.notice <= dateRange.to
        : true;

    return matchSearch && matchDate;
  });
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Last 7 Days");

  const options = ["Recently Added", "Ascending", "Descending"];
  return (
    <>
<div  style={{ padding: "15px", background: "#f8f9fa",  }} >
     <TerminationHeader/>
           <Card style={{ borderRadius: "5px" }}>
        
        {/* HEADER */}
        <div
          style={{
            padding: "15px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <h5 style={{ margin: 0 }}>Termination List</h5>

          <div style={{ display: "flex", gap: "10px" }}>
            
            {/* DATE DROPDOWN */}
            <div style={{ position: "relative" }}>
              <div
                onClick={() => setShowDropdown(!showDropdown)}
                style={{
                  border: "1px solid #e5e7eb",
                  padding: "8px 12px",
                  borderRadius: "6px",
                  width: "230px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <FaCalendarAlt style={{color:"#373636"}} />
                {dateRange.from
                  ? `${displayDate(dateRange.from)} - ${displayDate(
                      dateRange.to
                    )}`
                  : "04/22/2026 - 04/28/2026"}
              </div>

              {showDropdown && (
                <div
                  style={{
                    position: "absolute",
                    top: "45px",
                    width: "220px",
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                  }}
                >
                  {[
                    "Today",
                    "Yesterday",
                    "Last 7 Days",
                    "Last 30 Days",
                    "This Year",
                    "Next Year",
                    "Custom Range",
                  ].map((item) => (
                    <div
                      key={item}
                      onClick={() => {
                        setSelectedRange(item);
                        if (item !== "Custom Range") {
                          setDateRange(calculateDates(item));
                        }
                        setShowDropdown(false);
                      }}
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        background:
                          selectedRange === item
                            ? "#f97316"
                            : "transparent",
                        color:
                          selectedRange === item ? "#fff" : "#000",
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* SORT BUTTON */}
    <div style={{ position: "relative" }}>
      
      {/* BUTTON */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          border: "1px solid #e5e7eb",
          padding: "8px 12px",
          borderRadius: "6px",
          background: "#fff",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          fontSize: "14px",
          minWidth: "170px",
        }}
      >
        <span style={{ color: "#6b7280" }}>Sort By :</span>
        <strong>{selected}</strong>
        <FaChevronDown style={{ marginLeft: "auto", fontSize: "12px" }} />
      </div>

      {/* DROPDOWN */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "45px",
            right: 0,
            width: "180px",
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "10px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
            padding: "8px 0",
            zIndex: 1000,
          }}
        >
          {options.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                setSelected(item);
                setOpen(false);
              }}
              style={{
                padding: "10px 15px",
                cursor: "pointer",
                fontSize: "14px",
                color: "#111",
              }}
              onMouseEnter={(e) =>
                (e.target.style.background = "#f9fafb")
              }
              onMouseLeave={(e) =>
                (e.target.style.background = "transparent")
              }
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
          </div>
        </div>

        {/* FILTER BAR */}
        <div
          style={{
            padding: "10px 15px",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div>
            Row Per Page{" "}
            <Form.Select
              style={{ width: "80px", display: "inline-block" }}
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(e.target.value)}
            >
              <option>10</option>
              <option>25</option>
            </Form.Select>{" "}
            Entries
          </div>

          <Form.Control
            placeholder="Search"
            style={{ width: "200px" }}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* TABLE */}
        <div className="table-responsive">
          <Table>
            <thead style={{ background: "#f9fafb" }}>
              <tr>
                <th></th>
                <th>Employee</th>
                <th>Department</th>
                <th>Type</th>
                <th>Notice</th>
                <th>Reason</th>
                <th>Resignation</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filteredData.slice(0, rowsPerPage).map((item) => (
                <tr key={item.id}>
                  <td><Form.Check /></td>

                  <td>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={item.image}
                        alt=""
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          marginRight: "10px",
                        }}
                      />
                      {item.name}
                    </div>
                  </td>

                  <td>{item.department}</td>
                  <td>{item.type}</td>
                  <td>{item.notice}</td>
                  <td>{item.reason}</td>
                  <td>{item.resignation}</td>

                  <td>
                    {/* <FaEdit
                      style={{ marginRight: "10px", cursor: "pointer" }}
                      onClick={() => {
                        setSelectedItem(item);
                        setShowEdit(true);
                      }}
                    />
                    <FaTrash
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSelectedItem(item);
                        setShowDelete(true);
                      }}

                    /> */}

                             <div className="d-flex gap-3">
  <FaEdit
    style={{
      cursor: "pointer",
      color: "#666d75", // light gray
      fontSize: "14px",
    }}
    onClick={() => {
                        setSelectedItem(item);
                        setShowEdit(true);
                      }}
  />

  <RiDeleteBin6Line
    style={{
      cursor: "pointer",
      color: "#666d75", // even lighter gray
      fontSize: "14px",
    }}
    onClick={() => {
                        setSelectedItem(item);
                        setShowDelete(true);
                      }}
  />
</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>

      {/* MODALS */}
      <EditTerminationModal
        show={showEdit}
        handleClose={() => setShowEdit(false)}
        data={selectedItem}
      />

      <DeleteTerminationModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
      />
</div>
    </>
  );
};

export default TerminationPage;